import { useStores } from 'stores/utils/hooks/useStores'

/**
 * Returns the voucher amount in Euro based on the requested loan amount:
 *   >= 50 000  → 150 €
 *   >= 20 000  → 100 €
 *   otherwise  → null (voucher not applicable)
 */
export const getVoucherAmount = (loanAmount: number): number | null => {
  if (loanAmount >= 50000) return 150
  if (loanAmount >= 20000) return 100
  return null
}

const useVoucherAmount = (): number | null => {
  const { traversal } = useStores()
  return getVoucherAmount(traversal.data.common.amount)
}

export default useVoucherAmount
